import { render, staticRenderFns } from "./Weekpicker.vue?vue&type=template&id=37c52586&scoped=true"
import script from "./Weekpicker.vue?vue&type=script&lang=js"
export * from "./Weekpicker.vue?vue&type=script&lang=js"
import style0 from "./Weekpicker.vue?vue&type=style&index=0&id=37c52586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c52586",
  null
  
)

export default component.exports